import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { takeUntil } from 'rxjs/operators'
import { TranslateService } from '@ngx-translate/core'

import { DialogService } from '@shared/dialogs/dialog.service'
import { ChatCreateFormComponent } from '@app/modules/client/messenger/components/chat-create-form/chat-create-form.component'
import { DestroyService } from '@core/services/destroy.service'
import { PermissionsService } from '@app/shared/services/permissions.service'
import { PermissionsSource } from '@app/core/types/permissions.source'

@Component({
  selector: 'lin-chat-create-button',
  templateUrl: './chat-create-button.component.html',
  styleUrls: ['./chat-create-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
  standalone: false,
})
export class ChatCreateButtonComponent implements OnInit {
  @Input() isDefault = false

  get isChatCreate(): boolean {
    return this.permissionsService.hasPermissionSync(PermissionsSource['MESSENGER.CREATE_CHAT'])
  }

  private title: string

  constructor(
    private readonly dialogService: DialogService,
    private readonly translateService: TranslateService,
    private readonly destroyService: DestroyService,
    private readonly permissionsService: PermissionsService,
  ) {}

  ngOnInit(): void {
    this.initTitle()
  }

  handleCreateChat(): void {
    this.dialogService
      .open(ChatCreateFormComponent, this.title, { scope: 'create' }, undefined, undefined)
      .afterClosed()
      .pipe(takeUntil(this.destroyService))
      .subscribe()
  }

  private initTitle(): void {
    const translateTitle = 'CLIENT.MESSENGER.CHAT_CREATE.TITLE'
    this.title = <string>this.translateService.instant(translateTitle)
  }
}
